import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerBackward = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20.335 28.5412L18.835 29.4072L3.64453 20.637V18.905L18.835 10.1348L20.335 11.0008V18.8897L35.499 10.1348L36.999 11.0008V28.5412L35.499 29.4072L20.335 20.6523V28.5412Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcPlayerBackward);
export { ForwardRef as ReactComponent };
